import { lowerCaseFirstLetter } from "@utilities";

// creates object from all checkboxes 'Keys and Values'
const getAllCheckboxesKeyValueFromAPI = (filters: any) => {
  let checkboxesData = {};

  filters.forEach((item) => {
    if (item.isDropdown === true) {
      item.items.forEach((dropdownItem) => {
        checkboxesData = {
          ...checkboxesData,
          [lowerCaseFirstLetter(dropdownItem.value)]: dropdownItem.isChecked, // key/value pair (key is item.value + value is item.isChecked)
        };
      });
    } else {
      checkboxesData = { ...checkboxesData, [lowerCaseFirstLetter(item.value)]: item.isChecked }; // key/value pair (key is item.value + value is item.isChecked)
    }
  });

  return checkboxesData;
};

export default getAllCheckboxesKeyValueFromAPI;
